import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Angular normally prevents XSS attacks by sanitizing html content.
 * For example a user can put html code in a comment box and without this safety
 * this code could be executed by mistake. It also puts the 'unsafe' word before links that contains some
 * keyword like 'external', 'ftp', 'sms' and so on.
 * This pipe bypasses this function and says that this html code that was
 * written is safe and can be used as it is.
 */
@Pipe({ name: 'keepHtml', pure: true })
export class EscapeHtmlPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	/**
	 * This function takes the inner html code and calls the 'bypassSecurityTrustHtml' method
	 * which says angular that this code which was written by us is safe and can be used
	 *
	 * @param content The html code as a string that will be given to the 'bypassSecurityTrustHtml' method
	 */
	transform(content: string) {
		return this.sanitizer.bypassSecurityTrustHtml(content);
	}
}
